export default {
  enabled: true,
  hjid: 1338060,
  hjsv: 6,
};
